<template>
  <div class="split-event">
    <AppModal v-if="showModal"
              :submitTxt="i18n[locale].btn"
              @close="closeModal"
              :isShowFooter="false">
      <h1 slot="header" @click.stop>{{ i18n[locale].split }} {{ lesson.title }}, {{ lesson.start | showDate }}</h1>
      <div slot="body" class="form" @click.stop>
        <div class="origin-lesson">
          <p class="label">{{ i18n[locale].original_lesson }}</p>
          <div class="flex border pad-10 relative">
            <p>{{ lesson.title }}</p>
            <div class="lesson_times">
              <div>, kl. {{ lesson.start | LT }}</div>
              <div class="lesson_times__seperator"> -</div>
              <div>{{ lesson.end | LT }}</div>
            </div>
            <div class="marg-10-left">
              ({{ i18n[locale].duration }}: {{ oldDuration }} {{ i18n[locale].minutes }})
            </div>
          </div>
        </div>
        <h3 class="marg-24-top flex align-center">
          <span class="icon-clock"></span><span class="marg-5-left">
          {{ i18n[locale].when_is_the_split }}
        </span>
        </h3>
        <div class="flex align-center split-input-wrapper">
          <timeInput
            refs="timeinput"
            class="split-lesson-input"
            id="focus"
            :date="newLessonStart"
            @changed="setStartTime">
          </timeInput>
        </div>
        <p class="label">{{ i18n[locale].split_lessons }} </p>
        <div class="flex border pad-10 marg-5-bottom relative">
          <p>{{ lesson.title }}</p>
          <div class="lesson_times">
            <div>, {{ lesson.start | LT }}</div>
            <div class="lesson_times__seperator"> -</div>
            <div>{{ newLessonStart | LT }}</div>
          </div>
          <div class="marg-10-left">
            ({{ i18n[locale].duration }}: {{ lessonDuration }} {{ i18n[locale].minutes }})
          </div>
        </div>
        <div class="flex border pad-10 relative">
          <div class="lesson__border-left" style="{borderColor: lesson.color}"></div>
          <p>{{ lesson.title }}</p>
          <div class="lesson_times">
            <div>, {{ newLessonStart | LT }}</div>
            <div class="lesson_times__seperator"> -</div>
            <div>{{ lesson.end | LT }}</div>
          </div>
          <div class="marg-10-left">
            ({{ i18n[locale].duration }}: {{ newLessonDuration }} {{ i18n[locale].minutes }})
          </div>
        </div>
        <p class="italic">{{ i18n[locale].everything_will_be_cloned }}</p>
        <div class="modal-footer modal-footer__flex">
          <button class="do-bttn" @click.stop="closeModal">
            {{ $t('vue2.common.cancel') }}
          </button>
          <button class="do-bttn do-bttn--submit" :class="{'do-bttn--submit--loading': isSubmitting}" @click.stop="submit">
            {{ $t('vue2.common.save') }}
          </button>
        </div>
      </div>
    </AppModal>
  </div>
</template>


<script>
import timeInput from '../timechanger/TimeInput.vue'
import AppModal from '../common/AppModal'
import docendo from '../../docendo'
import Moment from 'moment'
import {extendMoment} from 'moment-range'

var moment = extendMoment(Moment)

export default {
  components: {AppModal, timeInput},
  props: {
    user: {
      type: Object
    },
    lesson: {
      type: Object
    }
  },
  filters: {
    LT (dateTime) {
      return moment(dateTime).format('LT')
    },
    showDate (dateTime) {
      return moment(dateTime).format('dddd, D. MMM')
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    allEventsInAHash () {
      return this.$store.state.subs.allEventsInAHash
    },
    newCurrentLessonEnd () {
      return moment(this.newLessonStart)
    },
    oldDuration () {
      let duration = moment.duration(moment(this.lesson.end).diff(this.lesson.start))
      return duration.asMinutes()
    },
    newLessonDuration () {
      let duration = moment.duration(moment(this.lesson.end).diff(this.newLessonStart))
      return duration.asMinutes()
    },
    lessonDuration () {
      let duration = moment.duration(this.newCurrentLessonEnd.diff(this.lesson.start))
      return duration.asMinutes()
    }
  },
  data () {
    return {
      i18n: {
        da: {
          split: 'Opdel',
          original_lesson: 'Nuværende lektion',
          duration: 'Varighed',
          minutes: 'minutter',
          when_is_the_split: 'På hvilket tidspunkt vil du dele lektion i to?',
          everything_will_be_cloned: 'Alt ved den oprindelige brik bliver kopieret dvs. undervisere, vikarer, noter osv.',
          split_lessons: 'Lektionen vil så blive delt til flg. lektioner: ',
          btn: 'Opdel lektion'
        },
        nb: {
          split: 'Del opp',
          original_lesson: 'Nåværende time',
          duration: 'Lengde',
          minutes: 'minutter',
          when_is_the_split: 'På hvilket tidspunkt skal timen deles i to?',
          everything_will_be_cloned: 'Alt i den opprinnelige timen blir kopiert dvs. undervisere, vikarer, notater osv.',
          split_lessons: 'Timen vil så bli delt opp til følgende timer: ',
          btn: 'Del opp timen'
        },
        en: {
          split: 'Split',
          original_lesson: 'Original lesson',
          duration: 'Duration',
          minutes: 'minutes',
          when_is_the_split: 'At what time should the lesson be split in two?',
          everything_will_be_cloned: 'All information from the original lesson will be copied i.e. teachers, substitutes, notes etc.',
          split_lessons: 'The lesson will be divided into the following lessons:',
          btn: 'Split lesson'
        }
      },
      showModal: true,
      newLessonStart: 8,
      newLessonEnd: this.lesson.end,
      isSubmitting: false
    }
  },
  methods: {
    submit () {
      this.isSubmitting = true
      docendo.splitEvent(this.lesson.id, moment(this.newLessonStart).toISOString(), data => {
        JSON.parse(data).forEach(lesson => {
          this.allEventsInAHash[lesson.id] ? this.$store.commit('updateEventOnAllEventsInAHash', lesson) : this.$store.commit('addANewEvent', lesson)
        })
        this.isSubmitting = false
        this.$emit('submitted')
        this.showModal = false
      }, failure => {
        console.log('failure', failure)
      })
    },
    closeModal () {
      this.$emit('closeSplitEvent')
      this.showModal = false
    },
    setStartTime (val) {
      let number = moment(val, 'LT') // check if number
      if (isNaN(number)) {
        this.newLessonStart = this.newLessonStart
        return
      } else {
        let hours = moment(number).format('HH')
        let minutes = Math.round(moment(number).format('mm') / 5) * 5
        let _newDate = moment(this.newLessonStart).set({'hour': hours, 'minute': minutes})
        if (hours * 1 === 23 && minutes * 1 === 55) {
          _newDate = moment(this.newLessonStart).set({'hour': hours, 'minute': 50})
        }
        // CANNOT BE BEFORE ORIGINAL.START || AFTER ORIGINAL.END
        if (moment(_newDate).isSameOrBefore(this.lesson.start)) {
          this.newLessonStart = this.newLessonStart
          return
        }
        if (moment(_newDate).isSameOrAfter(this.lesson.end)) {
          this.newLessonStart = this.newLessonStart
          return
        }
        this.newLessonStart = _newDate
      }
    },
    createInitialSplit () {
      const start = this.lesson.start
      const end = this.lesson.end
      const diffInMinutes = moment(end).diff(moment(start), 'minutes')
      // Make diff to closest 5 minutes
      let minutes = Math.round((diffInMinutes / 2) / 5) * 5
      this.newLessonStart = moment(this.lesson.end).subtract(minutes, 'minutes')
    }
  },
  beforeMount () {
    this.createInitialSplit()
  },
  created () {
    this.$nextTick(() => {
      document.getElementById('focus').focus()
    })
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';

.lesson_times {
  display: flex;
  align-items: center;
}

.lesson_times__seperator {
  margin: 0 5px;
}

.form {
  padding: 40px;
}

.split-lesson-input {
  padding: 10px;
  text-align: center;
  max-width: 90px;
  font-size: 16px;
  border: 2px solid #ccc;
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: none;
  background: #ffffff;
}

input#focus {
  transition: border 0.45s;
}

input#focus:focus {
  border-color: var(--blue);
}

.label {
  text-transform: uppercase;
  color: #a2a3a6;
  font-weight: bold;
  margin-bottom: 0;
}

.split-input-wrapper {
  margin-bottom: 32px;
  margin-top: 8px;
}

.marg-24-top {
  margin-top: 24px;
}

.italic {
  font-style: italic;
  margin-top: 8px;
}

.modal-footer__flex {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem;
}
</style>



// WEBPACK FOOTER //
// SubsEventSplit.vue?c3eb4d9c